"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var IconButtonDropdown_component_exports = {};
__export(IconButtonDropdown_component_exports, {
  IconButtonDropdown: () => IconButtonDropdown
});
module.exports = __toCommonJS(IconButtonDropdown_component_exports);
var import_react = __toESM(require("react"));
var import_react2 = require("react");
var import_useOnBlur = require("../../../utils/useOnBlur/useOnBlur.hook");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_keyBy = __toESM(require("lodash/keyBy"));
var import_IconButton = require("../IconButton/IconButton.component");
var import_DropdownItem = require("../../atoms/DropdownItem/DropdownItem.component");
var import_IconButtonDropdown = require("./IconButtonDropdown.styled");
var _excluded = ["ariaLabel", "icon", "activatorRef", "disabled", "listOpen", "toggleList", "darkMode"], _excluded2 = ["id", "children"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var DropdownTogglerButton = function DropdownTogglerButton2(_ref) {
  var ariaLabel = _ref.ariaLabel, _ref$icon = _ref.icon, icon = _ref$icon === void 0 ? "more-ver" : _ref$icon, activatorRef = _ref.activatorRef, disabled = _ref.disabled, listOpen = _ref.listOpen, toggleList = _ref.toggleList, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react2.useState)(listOpen), _useState2 = _slicedToArray(_useState, 2), isListOpen = _useState2[0], setIsListOpen = _useState2[1];
  (0, import_react2.useEffect)(function() {
    return setIsListOpen(listOpen);
  }, [listOpen]);
  return /* @__PURE__ */ import_react.default.createElement(import_IconButtonDropdown.StyledIconButtonTitle, null, /* @__PURE__ */ import_react.default.createElement(import_IconButton.IconButton, {
    "aria-expanded": isListOpen,
    "aria-haspopup": true,
    "data-toggle": "dropdown",
    icon,
    "aria-label": ariaLabel,
    onClick: toggleList,
    disabled,
    ref: activatorRef,
    darkMode,
    dataDpAnalyticsId: props.dataDpAnalyticsId,
    "data-testid": "icon-button-dropdown"
  }));
};
var IconButtonDropdown = function IconButtonDropdown2(_ref2) {
  var className = _ref2.className, ariaLabel = _ref2.ariaLabel, icon = _ref2.icon, disabled = _ref2.disabled, list = _ref2.list, _ref2$listPlacement = _ref2.listPlacement, listPlacement = _ref2$listPlacement === void 0 ? "bottom" : _ref2$listPlacement, _ref2$maxVisibleEleme = _ref2.maxVisibleElements, maxVisibleElements = _ref2$maxVisibleEleme === void 0 ? 5 : _ref2$maxVisibleEleme, offset = _ref2.offset, darkMode = _ref2.darkMode, dataDpAnalyticsId = _ref2.dataDpAnalyticsId;
  var _useState3 = (0, import_react2.useState)(void 0), _useState4 = _slicedToArray(_useState3, 2), selected = _useState4[0], setSelected = _useState4[1];
  var _useState5 = (0, import_react2.useState)(false), _useState6 = _slicedToArray(_useState5, 2), isListOpen = _useState6[0], setIsListOpen = _useState6[1];
  var activatorRef = (0, import_react2.useRef)(null);
  var wrapperRef = (0, import_react2.useRef)(null);
  var firstValidElementIndexAvailable = list.indexOf(list.find(function(el) {
    return !el.disabled;
  }));
  var setFocusOnMenuIcon = function setFocusOnMenuIcon2() {
    activatorRef.current.focus();
  };
  var closeAndFocus = function closeAndFocus2() {
    setIsListOpen(false);
    setFocusOnMenuIcon();
  };
  var ifHandleSelect = function ifHandleSelect2(id) {
    var item = list.find(function(i) {
      return i.id === id;
    });
    if (item.handleOnSelect) {
      item.handleOnSelect(id);
    }
  };
  var selectItem = function selectItem2(id) {
    if (!disabled) {
      setSelected(id);
      closeAndFocus();
    }
  };
  (0, import_useOnClickOutside.useOnClickOutside)(wrapperRef, function() {
    setIsListOpen(false);
  });
  (0, import_useOnBlur.useOnBlur)(wrapperRef, function() {
    setTimeout(function() {
      return setIsListOpen(false);
    }, 200);
  });
  (0, import_useOnKeydown.useOnKeydown)(activatorRef, function(keyList, ev) {
    ev.stopPropagation();
    var ArrowUp = keyList.ArrowUp, ArrowDown = keyList.ArrowDown;
    if (ArrowDown) {
      setIsListOpen(true);
      wrapperRef.current.focus();
    }
    if (ArrowUp) {
      if (isListOpen)
        return;
      setIsListOpen(true);
      wrapperRef.current.focus();
      var buttons = wrapperRef.current.querySelectorAll('button[role="menuitem"]:not([disabled])');
      setTimeout(function() {
        buttons[buttons.length - 1].focus();
      }, 10);
    }
  });
  (0, import_useOnKeydown.useOnKeydown)(wrapperRef, function(keyList, event) {
    var _wrapperRef$current;
    var ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, Escape = keyList.Escape, Enter = keyList.Enter, Space = keyList[" "], Home = keyList.Home, End = keyList.End;
    var buttonsNotDisabled = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.querySelectorAll('button[role="menuitem"]:not([disabled])');
    var buttonsId = Object.keys((0, import_keyBy.default)(buttonsNotDisabled, "id"));
    var activeItem = document.activeElement;
    var currentPosition = buttonsId.indexOf(activeItem.id);
    var dropItemsSize = buttonsNotDisabled.length - 1;
    if (ArrowUp) {
      var pos = currentPosition <= 0 ? dropItemsSize : currentPosition - 1;
      if (buttonsNotDisabled[pos]) {
        buttonsNotDisabled[pos].focus();
      }
    }
    if (ArrowDown) {
      var _pos = [dropItemsSize, -1].includes(currentPosition) ? 0 : currentPosition + 1;
      if (buttonsNotDisabled[_pos]) {
        buttonsNotDisabled[_pos].focus();
      }
    }
    if (Escape) {
      closeAndFocus();
    }
    if (Enter || Space) {
      event.preventDefault();
      selectItem(activeItem.id);
      ifHandleSelect(activeItem.id);
    }
    if (Home) {
      event.preventDefault();
      if (isListOpen) {
        event.stopPropagation();
      }
      buttonsNotDisabled[0].focus();
    }
    if (End) {
      event.preventDefault();
      if (isListOpen) {
        event.stopPropagation();
      }
      buttonsNotDisabled[buttonsNotDisabled.length - 1].focus();
    }
  });
  (0, import_react2.useEffect)(function() {
    if (isListOpen) {
      var buttons = wrapperRef.current.querySelectorAll('button[role="menuitem"]');
      setTimeout(function() {
        buttons[firstValidElementIndexAvailable].focus();
      }, 200);
    }
  });
  var toggleList = function toggleList2() {
    setIsListOpen(!isListOpen);
  };
  var renderList = list.map(function(_ref3) {
    var id = _ref3.id, children = _ref3.children, elementProps = _objectWithoutProperties(_ref3, _excluded2);
    return /* @__PURE__ */ import_react.default.createElement(import_DropdownItem.DropdownItem, _extends({
      key: id,
      id,
      isSelected: id === selected,
      handleOnSelect: selectItem,
      onClick: selectItem,
      ariaSelected: false,
      tabIndex: -1
    }, elementProps), children);
  });
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(DropdownTogglerButton, {
    ariaLabel,
    icon,
    activatorRef,
    disabled,
    listOpen: isListOpen,
    toggleList,
    darkMode,
    dataDpAnalyticsId
  }), /* @__PURE__ */ import_react.default.createElement(import_IconButtonDropdown.StyledIconButtonDropdownContentWrapper, {
    className,
    ref: wrapperRef
  }, isListOpen && /* @__PURE__ */ import_react.default.createElement(import_IconButtonDropdown.StyledIconButtonPopover, {
    maxHeight: maxVisibleElements * 50,
    "aria-activedescendant": selected === null || selected === void 0 ? void 0 : selected.id,
    isOpen: true,
    placement: listPlacement,
    offset,
    referenceElem: activatorRef,
    role: "menu"
  }, renderList)));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IconButtonDropdown
});
//# sourceMappingURL=IconButtonDropdown.component.js.map